/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Input } from 'reactstrap';

interface SearchBoxOptionsInterface {
  value: string;
  placeholder?: string;
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const SearchBox = (props: SearchBoxOptionsInterface) => {
  return (
    <div className='search-box'>
      <Input
        placeholder={props.placeholder ?? 'Search'}
        onChange={(e) => props.handleOnChange(e)}
        value={String(props.value)}
        className='border-ThemeBorderDefault text-md'
        data-testid='survey-overview-search-metrics'
      />
    </div>
  );
};
